import { useEffect, useRef, useState } from 'react';
import { depoimentosPalestra, FONTE_GOOGLE } from '../../../mocks/depoimentos';

function useInView(threshold = 0.1) {
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      ([e]) => { if (e.isIntersecting) { setVisible(true); obs.disconnect(); } },
      { threshold }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, [threshold]);
  return { ref, visible };
}

const lista = depoimentosPalestra.slice(0, 6);

export default function TestimonialsSection() {
  const { ref: headerRef, visible: headerVisible } = useInView(0.2);
  const { ref: gridRef, visible: gridVisible } = useInView(0.05);

  return (
    <section className="py-20 bg-white dark:bg-gray-900">
      <div className="container mx-auto px-4">

        <div
          ref={headerRef}
          className="text-center mb-12 transition-all duration-700"
          style={{ opacity: headerVisible ? 1 : 0, transform: headerVisible ? 'translateY(0)' : 'translateY(24px)' }}
        >
          <div className="inline-flex items-center gap-2 px-3 py-1.5 bg-teal-50 dark:bg-teal-900/30 border border-teal-100 dark:border-teal-800 rounded-full mb-5">
            <i className="ri-star-smile-line text-teal-600 dark:text-teal-400 text-sm"></i>
            <span className="text-teal-700 dark:text-teal-300 text-xs font-semibold uppercase tracking-wider">
              Avaliações no Google
            </span>
          </div>
          <h2 className="font-heading text-4xl md:text-5xl font-bold text-gray-900 dark:text-gray-50 mb-4">
            O que dizem nossos clientes
          </h2>
          <p className="font-body text-xl text-gray-600 dark:text-gray-300 max-w-3xl mx-auto">
            Avaliações reais publicadas no perfil da STIB no Google.
          </p>
        </div>

        <div
          ref={gridRef}
          className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto"
        >
          {lista.map((d, i) => (
            <figure
              key={d.nome}
              className="flex flex-col h-full bg-gray-50 dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-2xl p-7 transition-all duration-700"
              style={{
                opacity: gridVisible ? 1 : 0,
                transform: gridVisible ? 'translateY(0)' : 'translateY(20px)',
                transitionDelay: `${Math.min(i, 5) * 80}ms`,
              }}
            >
              <div className="flex gap-0.5 mb-4 text-amber-400" aria-label="5 de 5 estrelas">
                {[0, 1, 2, 3, 4].map((s) => (
                  <i key={s} className="ri-star-fill text-base"></i>
                ))}
              </div>
              <blockquote className="font-body text-gray-700 dark:text-gray-200 leading-relaxed flex-1">
                {d.texto}
              </blockquote>
              <figcaption className="mt-6 pt-5 border-t border-gray-200 dark:border-gray-700">
                <div className="font-heading font-semibold text-gray-900 dark:text-gray-50">{d.nome}</div>
                {d.contexto && (
                  <div className="font-body text-sm text-gray-500 dark:text-gray-400 mt-0.5">{d.contexto}</div>
                )}
              </figcaption>
            </figure>
          ))}
        </div>

        <p className="mt-10 text-center font-body text-sm text-gray-500 dark:text-gray-400">
          Depoimentos publicados por clientes no Google.{' '}
          <a
            href={FONTE_GOOGLE}
            target="_blank"
            rel="noopener noreferrer"
            className="underline underline-offset-2 hover:text-teal-600 dark:hover:text-teal-400"
          >
            Ver no Google
          </a>
        </p>
      </div>
    </section>
  );
}
